export default "__VITE_ASSET__BQ1HWF4a__"